
import { h } from "@stencil/core"

const ThreeDIcon = ():SVGElement => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.73492 0.0645734C8.89622 -0.0214118 9.09337 -0.0215316 9.25479 0.0642577L17.6843 4.54213C17.7782 4.58064 17.8611 4.64488 17.9195 4.73194C17.9732 4.81197 17.9992 4.9008 18 4.98871L18 5.00448V14.9996C18 15.1803 17.8968 15.3468 17.7302 15.4354L9.25957 19.9358C9.0984 20.0214 8.9016 20.0214 8.74043 19.9358L0.26984 15.4354C0.102907 15.3467 -0.000283614 15.1798 5.85533e-07 14.9989L0.0133406 5.10269C-0.0167371 4.98002 0.00334375 4.84668 0.0807387 4.73158C0.150897 4.62725 0.256143 4.55576 0.373334 4.52208L8.73492 0.0645734ZM1.014 5.856L1 14.7463L8.5 18.734L8.502 10.215L1.014 5.856ZM17 5.847L9.502 10.203L9.5 18.734L17 14.7463V5.847ZM8.99627 1L1.52 4.988L8.99212 9.33667L16.484 4.984L8.99627 1Z" fill="#344B60"/>
    </svg>
  );
};
export default ThreeDIcon;
